import { render, staticRenderFns } from "./WpHistoryDisclosureGrid.vue?vue&type=template&id=11959b95&scoped=true&"
import script from "./WpHistoryDisclosureGrid.vue?vue&type=script&lang=js&"
export * from "./WpHistoryDisclosureGrid.vue?vue&type=script&lang=js&"
import style0 from "./WpHistoryDisclosureGrid.vue?vue&type=style&index=0&id=11959b95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11959b95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11959b95')) {
      api.createRecord('11959b95', component.options)
    } else {
      api.reload('11959b95', component.options)
    }
    module.hot.accept("./WpHistoryDisclosureGrid.vue?vue&type=template&id=11959b95&scoped=true&", function () {
      api.rerender('11959b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/WpHistoryDisclosureGrid.vue"
export default component.exports